import { Component, ContentChildren, QueryList } from "@angular/core";
import { TagComponent } from "./tag.component";

@Component({
  selector: "snt-tag-list",
  templateUrl: "tag-list.component.html",
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ],
  standalone: false
})
export class TagListComponent {
  @ContentChildren(TagComponent) tags!: QueryList<TagComponent>;
}
